import Icon from "@components/general/Icon";
import { FC } from 'react';
import Tooltip from './general/Tooltip';

interface ISSRIconProps {
    title: string;
    icon: string;
}

const SSRIcon: FC<ISSRIconProps> = ({ title, icon }) => {
    return (
        <Tooltip
            title={title}
            placement='top'
        >
            <div className="ssr-icon">
                <Icon name={icon} />
            </div>
        </Tooltip>
    )
}

export default SSRIcon;